import { render, staticRenderFns } from "./WebSiteConfig.vue?vue&type=template&id=24cccb77&scoped=true&"
import script from "./WebSiteConfig.vue?vue&type=script&lang=js&"
export * from "./WebSiteConfig.vue?vue&type=script&lang=js&"
import style0 from "./WebSiteConfig.vue?vue&type=style&index=0&id=24cccb77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cccb77",
  null
  
)

export default component.exports